import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';
import FAQQuestion from './FAQQuestion';
import LinkButton from '../LinkButton/LinkButton';
import { DISCORD_LINK } from '../../constants';
import './FAQ.css'

const FAQ = () => {
  return (
    <div className='faq' id='faq'>
      <FontAwesomeIcon icon={faQuestionCircle} className='faq__icon'/>
      <label className='faq__title'>
        FREQUENTLY ASKED QUESTIONS
      </label>
      <label className='faq__text'>You can always reach the team on Telegram and Discord for any other information.</label>
      {FAQ_DATA.map(faq => 
        <FAQQuestion data={faq} />
      )}
      <LinkButton to={DISCORD_LINK} style={{marginTop: '20px'}}>Ask on discord</LinkButton> 
    </div>
  )
}

const FAQ_DATA = [
  {
    title: 'WHY AVALANCHE ?',
    content: 'Avalanche is a very exciting network, with fast transaction times and reasonable fees. We need a highly scalable platform for our fast-moving racing game, and Avalanche has all that is necessary to make our platform a success. Community and project collaborations also form a huge part of the benefits of avalanche. The team is already developing partnership to scale up the operation, An example of this is the partnership with ORAICHAIN which has already been finalized'
  },
  {
    title: 'WHEN IS THE GAME LAUNCHING ?',
    content: 'The Alpha demo was released to the community in March 2022 as per our initial roadmap. A beta Demo was released to the community on Friday 29th July 2022, after a very interesting Live Streaming event. Team will CONTINUE leaking footage of the progress until the live date.'
  },
  {
    title: 'HOW MUCH DOES IT COST ?',
    content: 'The NFKey PRE-SALE was 2 avax per NFT. RaceCar NFTs will have tiered pricing as per the Website. NFKey holders have been allocated a free RaceCar per NFKey. We decided to please our supporters offering different levels of discount depending the amount of $RaceX in your wallet!'
  },
  {
    title: 'HOW MANY CARS WILL I BE ALLOWED TO MINT ?',
    content: "There's a maximum of 20 Mints per transaction. All cars will be placed in a random generation sequence and the rarity you receive will be pure luck!"
  },
  {
    title: 'WILL THE CAR BE UPGRADEABLE ?',
    content: 'Yes, you will be able to upgrade your car in-game on both cosmetics and performances. It will also report modifications on out-game NFT!'
  },
  {
    title: 'HOW CAN I SEE MY NFT ?',
    content: 'You can see your NFT if you configure your wallet to display it, or on marketplaces such as KALAO and NFTrade. You can also see your NFT in our section “My NFTs”. And obviously, in our game and marketplace when out.'
  },
  {
    title: 'CAN I TRADE RaceCar NFT or NFKey ?',
    content: 'Yes you can. They can be traded through NFT Marketplaces as well as our own soon to be developed market place (Motor Dealership)! But why would you?'
  },
  {
    title: 'HOW DOES ROYALTIES WORK ?',
    content: "There will be a 3% royalty reflected to the owners of the RaceCar NFTs You will be able to claim reflection with a button in 'My NFTs'"
  },
  {
    title: 'HOW CAN I CONTACT THE TEAM ?',
    content: 'We are always available to our community through Discord and Telegram, and are more than happy to answer your questions.'
  },
]

export default FAQ;